import { Component } from '@angular/core';
import { urls  } from "../../services/apiUrls";
import { COPYRIGHT_DISCLAIMER_PAGE_URL_EXTERNAL, CREATIVE_COMMONS_ATTRIBUTION_URL_EXTERNAL } from 'src/app/models/external-urls';

@Component({
	selector: 'app-beachwatch-data-feeds',
	templateUrl: './beachwatch-data-feeds.component.html',
	styleUrls: ['./beachwatch-data-feeds.component.scss']
})
export class BeachwatchDataFeedsComponent {
	feedsApiUrl : string = urls.dataFeedsAPI;
	rssFeedsUrl : string =  urls.dataRSSFeeds;

	public CREATIVE_COMMONS_ATTRIBUTION_URL = CREATIVE_COMMONS_ATTRIBUTION_URL_EXTERNAL;
	public COPYRIGHT_DISCLAIMER_PAGE_URL = COPYRIGHT_DISCLAIMER_PAGE_URL_EXTERNAL;
}
